import { ApiError } from "../api/client";

/** Безопасный внутренний путь после входа / регистрации. */
export function safeAuthReturnPath(raw: string | null | undefined): string {
  if (!raw) return "/cabinet";
  if (raw.startsWith("/") && !raw.startsWith("//")) return raw;
  try {
    const u = new URL(raw, window.location.origin);
    if (u.origin === window.location.origin) {
      return `${u.pathname}${u.search}${u.hash}`;
    }
  } catch {
    /* ignore */
  }
  return "/cabinet";
}

/** Полная перезагрузка страницы — cookie сессии гарантированно подхватится. */
export function completeAuthRedirect(raw: string | null | undefined): void {
  window.location.replace(safeAuthReturnPath(raw));
}

export function isFetchAborted(signal?: AbortSignal): boolean {
  return Boolean(signal?.aborted);
}

/** Страница входа школьного контура (SSO через bez-part.ru). */
export const SCHOOL_ENTRY_PATH = "/school";

/**
 * Куда вести пользователя после 401/403.
 *
 * Школьный аккаунт нельзя отправлять на внешнюю форму email/пароля — там он
 * войти не может; внешний аккаунт нельзя отправлять на школьный SSO. Сервер
 * сообщает контур в кодах `main_site_only` / `wrong_contour`.
 */
export function authEntryPathForError(
  err: unknown,
  returnPath: string
): string {
  const externalEntry = `/login?return=${encodeURIComponent(returnPath)}`;
  if (!(err instanceof ApiError)) return externalEntry;
  if (err.code === "main_site_only") return SCHOOL_ENTRY_PATH;
  if (err.code === "wrong_contour") {
    return err.accountKind === "school" ? SCHOOL_ENTRY_PATH : externalEntry;
  }
  return externalEntry;
}

export function isUnauthorizedError(err: unknown): boolean {
  if (err instanceof ApiError) return err.status === 401;
  return (
    typeof err === "object" &&
    err !== null &&
    "status" in err &&
    (err as { status?: number }).status === 401
  );
}
